module.exports = __webpack_public_path__ + "static/media/power-quality.3986a01e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/power-quality.svg
// module id = 291
// module chunks = 0